import { render, staticRenderFns } from "./PetCard.vue?vue&type=template&id=28c5d82e&scoped=true&"
import script from "./PetCard.vue?vue&type=script&lang=js&"
export * from "./PetCard.vue?vue&type=script&lang=js&"
import style0 from "./PetCard.vue?vue&type=style&index=0&id=28c5d82e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c5d82e",
  null
  
)

export default component.exports